export class ErrorBase extends Error {}
